import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { UserListPagination } from './UserListPagination';
import { formatDateTime } from '../../utils/formatDate';
import { pageSlice } from '../../utils/pageSlice';

const DEFAULT_PAGE_SIZE = 10;

export function AuditTrail({ logs }) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const window = pageSlice(logs, page, pageSize);

  return (
    <Card className="govt-card">
      <CardHeader className="govt-card-header">
        <CardTitle className="text-lg">Audit Trail</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        {window.total === 0 ? (
          <p className="text-sm text-slate-500">No audit trail yet.</p>
        ) : (
          <div className="space-y-4">
            {window.items.map((log, index) => (
              <div key={log.id || `${window.page}-${index}`} className="timeline-item">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium text-sm capitalize">
                      {log.action?.replace(/_/g, ' ')}
                    </p>
                    <p className="text-xs text-slate-500">
                      By {log.performed_by_name} ({log.performed_by_role?.replace(/_/g, ' ')})
                    </p>
                  </div>
                  <span className="text-xs text-slate-400">{formatDateTime(log.timestamp)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
        <UserListPagination
          total={window.total}
          page={window.page}
          pageSize={window.pageSize}
          totalPages={window.totalPages}
          onPageChange={setPage}
          onPageSizeChange={(size) => {
            setPageSize(size);
            setPage(1);
          }}
          testIdPrefix="audit-page"
        />
      </CardContent>
    </Card>
  );
}
